import Profile from "views/examples/Profile";
import InvoiceScanner from "views/stockManager/InvoiceScanner";
import StockManagerDashboard from "views/stockManager/StockManagerDashboard";
import Inventory from "./views/stockManager/Inventory";
import Movements from "views/stockManager/Movements";
import Purchases from "views/stockManager/Purchases";
import AdjustmentForm from "views/stockManager/AdjustmentForm";
import MyLeaveRequests from "views/Rh/MyLeaveRequests";

const stockManagerRoutes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    icon: "ni ni-tv-2 text-success",
    component: <StockManagerDashboard />,
    layout: "/stock",
    sidebar: true,
  },
  {
    path: "/invoices/scan",
    name: "Scan Invoice",
    icon: "ni ni-zoom-split-in text-primary",
    component: <InvoiceScanner />,
    layout: "/stock",
    sidebar: true,
  },
  {
      path: "/profile",
      name: "User Profile",
      icon: "ni ni-single-02 text-yellow",
      component: <Profile />,
      layout: "/stock",
      sidebar: false,
    },
    {
  path: "/inventory",
  name: "Inventory",
  icon: "ni ni-tag text-success",
  component: <Inventory />,
  layout: "/stock",
  sidebar: true,
},
{
  path: "/movements",
  name: "Movements",
  icon: "ni ni-bullet-list-67 text-info",
  component: <Movements />,
  layout: "/stock",
  sidebar: true,
},
{
  path: "/purchases",
  name: "Purchases",
  icon: "ni ni-cart text-warning",
  component: <Purchases />,
  layout: "/stock",
  sidebar: true,
},
{
  path: "/adjustment",
  name: "Adjustment",
  icon: "ni ni-fat-add text-danger",
  component: <AdjustmentForm />,
  layout: "/stock",
  sidebar: true,
},
{
      path: "/my-leaves",
      name: "My Leave Requests",
      icon: "ni ni-calendar-grid-58",
      component: <MyLeaveRequests />,
      layout: "/stock",
      sidebar: true,
    },
  // future: { path: "/inventory", name: "Inventory", icon: "ni ni-tag", component: <InventoryPage />, layout: "/stock", sidebar: true },
];

export default stockManagerRoutes;